import React, { useEffect, useState } from 'react';
import { Button, Grid, Typography, Container, Paper, CircularProgress } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import Navbar from '../../../globals/components/Navbar';
import { useNavigate } from 'react-router';
import { apiClient } from '../../../globals/utils/api';

const VermostOutsiderStartBondRequestHistoric = () => {
  const navigate = useNavigate();
  const { handleSubmit, control, setValue } = useForm();
  const [bondTypes, setBondTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch bond types and states from APIs
  useEffect(() => {
    const fetchBondTypes = async () => {
      try {
        const response = await apiClient('/bondtypes/', 'GET');
        const list = Array.isArray(response) ? response : response?.data || [];
        const filteredBondTypes = list.filter(
          (bondType) => bondType.type !== 'Guardian-Minor'
        );
        const formattedBondTypes = filteredBondTypes.map((item) => ({
          value: item.type,
          label: item.type,
        }));
        setBondTypes(formattedBondTypes);

        // Set default bond type to Probate
        const defaultBondType = formattedBondTypes.find((item) => item.label === 'Probate');
        if (defaultBondType) {
          setValue('bondType', defaultBondType);
        }
      } catch (error) {
        console.error('Error fetching bond types:', error);
      }
    };

    const fetchStates = async () => {
      try {
        const response = await apiClient('/states/0/', 'GET');
        const list = Array.isArray(response) ? response : response?.data || [];
        const formattedStates = list.map((item) => ({
          value: item.state_code,
          label: item.state_name,
          id: item.bond_state_id,
        }));
        setStates(formattedStates);

        // Set default state to Florida
        const defaultState = formattedStates.find((item) => item.label === 'Florida');
        if (defaultState) {
          setValue('state', defaultState);
        }

        // Commented out localStorage functionality
        // const savedState = localStorage.getItem('selectedState');
        // if (savedState) {
        //   const parsedState = JSON.parse(savedState);
        //   setValue('state', parsedState); // Prefill state
        // }

        // const savedBondType = localStorage.getItem('selectedBondType');
        // if (savedBondType) {
        //   const parsedBondType = JSON.parse(savedBondType);
        //   setValue('bondType', parsedBondType); // Prefill bond type
        // }
      } catch (error) {
        console.error('Error fetching states:', error);
      }
    };

    setLoading(true);
    Promise.all([fetchBondTypes(), fetchStates()]).finally(() => setLoading(false));
  }, [setValue]);

  const onSubmit = (data) => {
    const { state, bondType } = data;

    // Commented out localStorage functionality
    localStorage.setItem('selectedState', JSON.stringify(state));
    localStorage.setItem('selectedBondType', JSON.stringify(bondType));

    // Navigate based on selected bond type
    if (bondType?.label === 'Probate') {
      navigate('/vermost-probate-bond-historic');
    } else if (bondType?.label === 'Guardianship') {
      navigate('/vermost-guardianship-bond-historic');
    } else if (bondType?.label === 'VA') {
      navigate('/vermost-va-bond-historic');
    } else if (bondType?.label === 'Trustee') {
      navigate('/vermost-trustee-bond-historic');
    } else if (bondType?.label === 'Blanket') {
      navigate('/vermost-blanket-bond-historic');
    }
    else {
      console.error('Unknown bond type:', bondType);
    }
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="sm" style={{ marginTop: '3rem' }}>
        <Paper elevation={3} style={{ padding: '2rem', backgroundColor: '#f5f5f5', borderRadius: '15px' }}>
          <Typography variant="h5" gutterBottom style={{ textAlign: 'center', fontWeight: 'bold' }}>
            Initiate Historic Bond Request
          </Typography>
          {loading ? (
            <CircularProgress style={{ display: 'block', margin: '0 auto' }} />
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                {/* State Dropdown */}
                <Grid item xs={12}>
                  <Controller
                    name="state"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={states}
                        placeholder="Select a State"
                        onChange={(value) => setValue('state', value)}
                        isSearchable
                      />
                    )}
                  />
                </Grid>

                {/* Bond Type Dropdown */}
                <Grid item xs={12}>
                  <Controller
                    name="bondType"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={bondTypes}
                        placeholder="Select a Bond Type"
                        onChange={(value) => setValue('bondType', value)}
                        isSearchable
                      />
                    )}
                  />
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12} style={{ textAlign: 'center', marginTop: '1rem' }}>
                  <Button type="submit" variant="contained" color="primary">
                    Start Request
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Paper>
      </Container>
    </>
  );
};

export default VermostOutsiderStartBondRequestHistoric;
